"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.supportedLanguages = void 0;
var supportedLanguages = exports.supportedLanguages = [{
  handle: 'en',
  label: 'English'
}, {
  handle: 'es',
  label: 'Spanish'
}];